import script from "./TalentProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TalentProfileCard.vue?vue&type=script&setup=true&lang=ts"

import "./TalentProfileCard.vue?vue&type=style&index=0&id=1ba0ff27&lang=scss"

const __exports__ = script;

export default __exports__